import {
	IsEmail,
	IsNotEmpty,
	//ValidationArguments,
	Length,
	Validate,
	ValidatorConstraintInterface,
	ValidationArguments,
	ValidatorConstraint,
} from 'class-validator'
import { validatePhoneNumber } from './phoneValidator'
import appConfig from 'app.config'
import { CountryCode } from 'libphonenumber-js'
//import appConfig from '../../app.config'
//import { IsValidZip } from './customDecorators'

interface IValidationContactInfo {
	readonly email: string
	readonly cellPhone: string
	//readonly zip: string
	//readonly city: string
	//readonly street: string
}

interface IValidationSupport {
	readonly subject: string
	readonly body: string
}

interface IValidationRefin {
	readonly refinAmount: string
}

const isBalticCountry = ['fi', 'ee', 'lt'].includes(appConfig.country)

@ValidatorConstraint({ name: 'customPhone', async: false })
export class CustomPhoneValidation implements ValidatorConstraintInterface {
	validate(mobileNumber: string, args: ValidationArguments) {
		console.log('validating')
		return validatePhoneNumber(
			mobileNumber,
			appConfig.country.toUpperCase() as CountryCode,
			isBalticCountry ? ['fi', 'ee', 'lt', 'lv'] : new Array(appConfig.country.toUpperCase() as CountryCode)
		)
	}
  
	defaultMessage(args: ValidationArguments) {
	  return 'InvalidPhone';
	}
  }

export class ValidationContactInfo implements IValidationContactInfo {
	//------------EMAIL-------------
	@IsNotEmpty({
		message: 'ValidateEmailRequired',
	})
	@IsEmail(undefined, {
		message: 'ValidateEmailInvalid',
	})
	public readonly email: string

	//------------CELLPHONE-------------
	//@IsMobilePhone(Locale[appConfig.country as keyof typeof Locale])
	@IsNotEmpty()
	@Validate(CustomPhoneValidation, {
		message: 'InvalidPhone',
	})
	public readonly cellPhone: string

	//------------ZIP-------------
	/*
	@IsValidZip(appConfig.country, {
		message: (args: ValidationArguments) => {
			switch (appConfig.country) {
				case 'fi':
				case 'se':
				case 'ee':
					return 'ValidateZip5Digits'
				case 'no':
					return 'ValidateZip4Digits'
				case 'lv':
					return 'Must be in form of LT-xxxx'
				default:
					return 'Invalid country'
			}
		}
	})
	@Matches(/^[A-Z0-9 _ -]*$/)
	@IsNotEmpty()
	*/
	//public readonly zip: string

	//------------CITY-------------
	/*
	@Matches(/^[a-zA-Z _ -]*$/)
	@IsNotEmpty({
		message: 'ValidateCityShort'
	})
	*/
	//public readonly city: string

	//------------ADDRESS-------------
	/*
	@Matches(/^[a-zA-Z0-9 / - _]*$/, {
		message: 'ValidateAddress'
	})
	*/
	//public readonly street: string

	constructor(
		custom: IValidationContactInfo = {
			email: '',
			cellPhone: '',
			//	zip: '',
			//	city: '',
			//	street: '',
		},
	) {
		this.email = custom.email
		this.cellPhone = custom.cellPhone
		//this.zip = custom.zip
		//this.city = custom.city
		//this.street = custom.street
	}
}

export class ValidationSupport implements IValidationSupport {
	//------------SUBJECT-------------
	@IsNotEmpty({
		message: 'ValidateRequired',
	})
	@Length(1, 50, {
		message: 'ValidateSubjectLength',
	})
	public readonly subject: string
	//------------BODY-------------
	@IsNotEmpty({
		message: 'ValidateRequired',
	})
	@Length(5, 1000, {
		message: 'ValidateBodyLength',
	})
	public readonly body: string

	constructor(
		custom: IValidationSupport = {
			subject: '',
			body: '',
		}
	) {
		this.subject = custom.subject
		this.body = custom.body
	}
}

export class ValidationRefin implements IValidationRefin {
	@IsNotEmpty({
		message: 'ValidateRequired',
	})
	public readonly refinAmount: string

	constructor(
		custom: IValidationRefin = {
			refinAmount: '',
		}
	) {
		this.refinAmount = custom.refinAmount
	}
}
